import { render } from "./TermsOfUses.vue?vue&type=template&id=3f3a49ca&scoped=true"
import script from "./TermsOfUses.vue?vue&type=script&lang=js"
export * from "./TermsOfUses.vue?vue&type=script&lang=js"

import "./TermsOfUses.vue?vue&type=style&index=0&id=3f3a49ca&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3a49ca"]])

export default __exports__